import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';
import slots from './modules/slots';
import timezone from './modules/timezone';
import notifications from './modules/notifications';

Vue.use(Vuex);

const timezoneState = createPersistedState({
  paths: ['timezone'],
});

export default new Vuex.Store({
  state: {
    showSideMenu: true,
    showNotificationsBar: false,
  },
  getters: {
    showNotificationsBar(state) {
      return state.showNotificationsBar;
    },
  },
  mutations: {
    TOGGLE_MENU(state) {
      state.showSideMenu = !state.showSideMenu;
    },
    TOGGLE_NOTIFICATIONS(state) {
      state.showNotificationsBar = !state.showNotificationsBar;
    },
  },
  actions: {
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },
    toggleNotifications({ commit }) {
      commit('TOGGLE_NOTIFICATIONS');
    },
  },
  modules: {
    auth,
    slots,
    timezone,
    notifications,
  },
  plugins: [timezoneState],
});
